/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderDiscountOperator } from './OrderDiscountOperator';
import {
    OrderDiscountOperatorFromJSON,
    OrderDiscountOperatorFromJSONTyped,
    OrderDiscountOperatorToJSON,
    OrderDiscountOperatorToJSONTyped,
} from './OrderDiscountOperator';
import type { OrderDiscountOrigin } from './OrderDiscountOrigin';
import {
    OrderDiscountOriginFromJSON,
    OrderDiscountOriginFromJSONTyped,
    OrderDiscountOriginToJSON,
    OrderDiscountOriginToJSONTyped,
} from './OrderDiscountOrigin';
import type { OrderDiscountFrequencyQualifier } from './OrderDiscountFrequencyQualifier';
import {
    OrderDiscountFrequencyQualifierFromJSON,
    OrderDiscountFrequencyQualifierFromJSONTyped,
    OrderDiscountFrequencyQualifierToJSON,
    OrderDiscountFrequencyQualifierToJSONTyped,
} from './OrderDiscountFrequencyQualifier';
import type { OrderDiscountType } from './OrderDiscountType';
import {
    OrderDiscountTypeFromJSON,
    OrderDiscountTypeFromJSONTyped,
    OrderDiscountTypeToJSON,
    OrderDiscountTypeToJSONTyped,
} from './OrderDiscountType';
import type { RelationshipType } from './RelationshipType';
import {
    RelationshipTypeFromJSON,
    RelationshipTypeFromJSONTyped,
    RelationshipTypeToJSON,
    RelationshipTypeToJSONTyped,
} from './RelationshipType';
import type { HandoffOptions } from './HandoffOptions';
import {
    HandoffOptionsFromJSON,
    HandoffOptionsFromJSONTyped,
    HandoffOptionsToJSON,
    HandoffOptionsToJSONTyped,
} from './HandoffOptions';
import type { OrderDiscountCalculation } from './OrderDiscountCalculation';
import {
    OrderDiscountCalculationFromJSON,
    OrderDiscountCalculationFromJSONTyped,
    OrderDiscountCalculationToJSON,
    OrderDiscountCalculationToJSONTyped,
} from './OrderDiscountCalculation';

/**
 * Represents a single discount for orders in the system.
 * @export
 * @interface OrderDiscount
 */
export interface OrderDiscount {
    /**
     * 
     * @type {string}
     * @memberof OrderDiscount
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof OrderDiscount
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDiscount
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof OrderDiscount
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDiscount
     */
    internalName?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDiscount
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderDiscount
     */
    businesses?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof OrderDiscount
     */
    priority: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDiscount
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDiscount
     */
    amountMax: number;
    /**
     * 
     * @type {boolean}
     * @memberof OrderDiscount
     */
    isReusableToAmountMax?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderDiscount
     */
    customers: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof OrderDiscount
     */
    subtotalMin: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDiscount
     */
    expiresAt?: number;
    /**
     * 
     * @type {OrderDiscountType}
     * @memberof OrderDiscount
     */
    type: OrderDiscountType;
    /**
     * 
     * @type {OrderDiscountCalculation}
     * @memberof OrderDiscount
     */
    calculation: OrderDiscountCalculation;
    /**
     * 
     * @type {OrderDiscountOrigin}
     * @memberof OrderDiscount
     */
    origin: OrderDiscountOrigin;
    /**
     * 
     * @type {boolean}
     * @memberof OrderDiscount
     */
    isEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderDiscount
     */
    isSingleUseUser: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderDiscount
     */
    isDisplayedGoFrens: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderDiscount
     */
    isSingleUseSystem: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderDiscount
     */
    isStackablePromo: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderDiscount
     */
    isFirstOrder: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderDiscount
     */
    isRestrictedToAssignedCodes?: boolean;
    /**
     * 
     * @type {Array<RelationshipType>}
     * @memberof OrderDiscount
     */
    referralTypes: Array<RelationshipType>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderDiscount
     */
    nftGroupings?: Array<string>;
    /**
     * 
     * @type {OrderDiscountOperator}
     * @memberof OrderDiscount
     */
    nftOperator?: OrderDiscountOperator;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderDiscount
     */
    codes?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof OrderDiscount
     */
    maxRedemptions?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDiscount
     */
    timesRedeemed?: number;
    /**
     * 
     * @type {OrderDiscountFrequencyQualifier}
     * @memberof OrderDiscount
     */
    useFrequencyQualifier?: OrderDiscountFrequencyQualifier;
    /**
     * 
     * @type {number}
     * @memberof OrderDiscount
     */
    useFrequency?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderDiscount
     */
    menuCategories?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderDiscount
     */
    menuItems?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OrderDiscount
     */
    image?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderDiscount
     */
    isBrandMapValid?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderDiscount
     */
    isBrandMapAutoApplied?: boolean;
    /**
     * 
     * @type {Array<HandoffOptions>}
     * @memberof OrderDiscount
     */
    handoffOptions?: Array<HandoffOptions>;
    /**
     * 
     * @type {string}
     * @memberof OrderDiscount
     */
    promoTokenReference?: string;
}



/**
 * Check if a given object implements the OrderDiscount interface.
 */
export function instanceOfOrderDiscount(value: object): value is OrderDiscount {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('amountMax' in value) || value['amountMax'] === undefined) return false;
    if (!('customers' in value) || value['customers'] === undefined) return false;
    if (!('subtotalMin' in value) || value['subtotalMin'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('calculation' in value) || value['calculation'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    if (!('isEnabled' in value) || value['isEnabled'] === undefined) return false;
    if (!('isSingleUseUser' in value) || value['isSingleUseUser'] === undefined) return false;
    if (!('isDisplayedGoFrens' in value) || value['isDisplayedGoFrens'] === undefined) return false;
    if (!('isSingleUseSystem' in value) || value['isSingleUseSystem'] === undefined) return false;
    if (!('isStackablePromo' in value) || value['isStackablePromo'] === undefined) return false;
    if (!('isFirstOrder' in value) || value['isFirstOrder'] === undefined) return false;
    if (!('referralTypes' in value) || value['referralTypes'] === undefined) return false;
    return true;
}

export function OrderDiscountFromJSON(json: any): OrderDiscount {
    return OrderDiscountFromJSONTyped(json, false);
}

export function OrderDiscountFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDiscount {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'label': json['label'],
        'internalName': json['internalName'] == null ? undefined : json['internalName'],
        'description': json['description'] == null ? undefined : json['description'],
        'businesses': json['businesses'] == null ? undefined : json['businesses'],
        'priority': json['priority'],
        'amount': json['amount'],
        'amountMax': json['amountMax'],
        'isReusableToAmountMax': json['isReusableToAmountMax'] == null ? undefined : json['isReusableToAmountMax'],
        'customers': json['customers'],
        'subtotalMin': json['subtotalMin'],
        'expiresAt': json['expiresAt'] == null ? undefined : json['expiresAt'],
        'type': OrderDiscountTypeFromJSON(json['type']),
        'calculation': OrderDiscountCalculationFromJSON(json['calculation']),
        'origin': OrderDiscountOriginFromJSON(json['origin']),
        'isEnabled': json['isEnabled'],
        'isSingleUseUser': json['isSingleUseUser'],
        'isDisplayedGoFrens': json['isDisplayedGoFrens'],
        'isSingleUseSystem': json['isSingleUseSystem'],
        'isStackablePromo': json['isStackablePromo'],
        'isFirstOrder': json['isFirstOrder'],
        'isRestrictedToAssignedCodes': json['isRestrictedToAssignedCodes'] == null ? undefined : json['isRestrictedToAssignedCodes'],
        'referralTypes': ((json['referralTypes'] as Array<any>).map(RelationshipTypeFromJSON)),
        'nftGroupings': json['nftGroupings'] == null ? undefined : json['nftGroupings'],
        'nftOperator': json['nftOperator'] == null ? undefined : OrderDiscountOperatorFromJSON(json['nftOperator']),
        'codes': json['codes'] == null ? undefined : json['codes'],
        'maxRedemptions': json['maxRedemptions'] == null ? undefined : json['maxRedemptions'],
        'timesRedeemed': json['timesRedeemed'] == null ? undefined : json['timesRedeemed'],
        'useFrequencyQualifier': json['useFrequencyQualifier'] == null ? undefined : OrderDiscountFrequencyQualifierFromJSON(json['useFrequencyQualifier']),
        'useFrequency': json['useFrequency'] == null ? undefined : json['useFrequency'],
        'menuCategories': json['menuCategories'] == null ? undefined : json['menuCategories'],
        'menuItems': json['menuItems'] == null ? undefined : json['menuItems'],
        'image': json['image'] == null ? undefined : json['image'],
        'isBrandMapValid': json['isBrandMapValid'] == null ? undefined : json['isBrandMapValid'],
        'isBrandMapAutoApplied': json['isBrandMapAutoApplied'] == null ? undefined : json['isBrandMapAutoApplied'],
        'handoffOptions': json['handoffOptions'] == null ? undefined : ((json['handoffOptions'] as Array<any>).map(HandoffOptionsFromJSON)),
        'promoTokenReference': json['promoTokenReference'] == null ? undefined : json['promoTokenReference'],
    };
}

export function OrderDiscountToJSON(json: any): OrderDiscount {
    return OrderDiscountToJSONTyped(json, false);
}

export function OrderDiscountToJSONTyped(value?: OrderDiscount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'label': value['label'],
        'internalName': value['internalName'],
        'description': value['description'],
        'businesses': value['businesses'],
        'priority': value['priority'],
        'amount': value['amount'],
        'amountMax': value['amountMax'],
        'isReusableToAmountMax': value['isReusableToAmountMax'],
        'customers': value['customers'],
        'subtotalMin': value['subtotalMin'],
        'expiresAt': value['expiresAt'],
        'type': OrderDiscountTypeToJSON(value['type']),
        'calculation': OrderDiscountCalculationToJSON(value['calculation']),
        'origin': OrderDiscountOriginToJSON(value['origin']),
        'isEnabled': value['isEnabled'],
        'isSingleUseUser': value['isSingleUseUser'],
        'isDisplayedGoFrens': value['isDisplayedGoFrens'],
        'isSingleUseSystem': value['isSingleUseSystem'],
        'isStackablePromo': value['isStackablePromo'],
        'isFirstOrder': value['isFirstOrder'],
        'isRestrictedToAssignedCodes': value['isRestrictedToAssignedCodes'],
        'referralTypes': ((value['referralTypes'] as Array<any>).map(RelationshipTypeToJSON)),
        'nftGroupings': value['nftGroupings'],
        'nftOperator': OrderDiscountOperatorToJSON(value['nftOperator']),
        'codes': value['codes'],
        'maxRedemptions': value['maxRedemptions'],
        'timesRedeemed': value['timesRedeemed'],
        'useFrequencyQualifier': OrderDiscountFrequencyQualifierToJSON(value['useFrequencyQualifier']),
        'useFrequency': value['useFrequency'],
        'menuCategories': value['menuCategories'],
        'menuItems': value['menuItems'],
        'image': value['image'],
        'isBrandMapValid': value['isBrandMapValid'],
        'isBrandMapAutoApplied': value['isBrandMapAutoApplied'],
        'handoffOptions': value['handoffOptions'] == null ? undefined : ((value['handoffOptions'] as Array<any>).map(HandoffOptionsToJSON)),
        'promoTokenReference': value['promoTokenReference'],
    };
}

